import { Inject, Injectable, PLATFORM_ID, signal } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Building } from '../models/building';

const STORAGE_KEY = 'admin_tools.selected_building';

@Injectable({ providedIn: 'root' })
export class BuildingContextService {
  readonly selected = signal<Building | null>(null);

  constructor(@Inject(PLATFORM_ID) private platformId: object) {
    if (isPlatformBrowser(this.platformId)) {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      if (raw) {
        try {
          this.selected.set(JSON.parse(raw) as Building);
        } catch {
          sessionStorage.removeItem(STORAGE_KEY);
        }
      }
    }
  }

  set(building: Building | null): void {
    this.selected.set(building);
    if (!isPlatformBrowser(this.platformId)) return;
    if (building) {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(building));
    } else {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  }

  clear(): void {
    this.set(null);
  }
}
